export const COMM_TOWER_POLYGON_OLD = [
    { lat: 37.723349728086525, lng: -122.12306988741254 },
    { lat: 37.72375706615411,  lng: -122.12487233187055 },
    { lat: 37.72504695525606,  lng: -122.12474358583783 },
    { lat: 37.72616710388316,  lng: -122.1239281942973 },
    { lat: 37.726099216569835, lng: -122.1206666281352 },
    { lat: 37.72501301109379,  lng: -122.11787713075971 },
    { lat: 37.72185613600666,  lng: -122.11658967043256 },
    { lat: 37.719445958006084, lng: -122.11903584505414 },
    { lat: 37.72032856750094,  lng: -122.12255490328168 },
  ];


  export const KELLER_FIRE_POLYGON = [
    { lat: 37.773843121376785, lng: -122.15725174422714 },
    { lat: 37.773444539401304, lng: -122.15666165824386 },
    { lat: 37.77372439505559,  lng: -122.15617886062118 },
    { lat: 37.7739279257752,   lng: -122.15566387649032 },
    { lat: 37.77430106397261,  lng: -122.15576043601486 },
    { lat: 37.77460635746069,  lng: -122.15559950347397 },
    { lat: 37.77474204305073,  lng: -122.15506306167099 },
    { lat: 37.77569183520855,  lng: -122.15470901008102 },
    //{ lat: 37.7757172759021,   lng: -122.15441933150741 },
    { lat: 37.775980162556394, lng: -122.15506306167099 },
    { lat: 37.77603104373634,  lng: -122.15571752067062 },
    { lat: 37.7756748747413,   lng: -122.1567582177684 },
    // { lat: 37.774860767737756, lng: -122.15708008285019 },
    { lat: 37.775174539207114, lng: -122.15730538840744 },
    { lat: 37.77433498553355,  lng: -122.15757360930893 },
    //{ lat: 37.77382616048543,  lng: -122.15734830375168 },
  ];

export const COMM_TOWER_POLYGON = [
  {"lat":37.717572783765434,"lng":-122.1224312110534},
  {"lat":37.7178304091424,"lng":-122.12252447038163},
  {"lat":37.71808803443243,"lng":-122.12261773035894},
  {"lat":37.718015379068945,"lng":-122.12294841940856},
  {"lat":37.71794272280774,"lng":-122.12327910780915},
  {"lat":37.71845797213338,"lng":-122.12346563394762},
  {"lat":37.71871559666575,"lng":-122.12355889799044},
  {"lat":37.71897322111128,"lng":-122.12365216268235},
  {"lat":37.719230845469816,"lng":-122.12374542802331},
  {"lat":37.719303502973176,"lng":-122.12341473432677},
  {"lat":37.719561127493215,"lng":-122.12350799925763},
  {"lat":37.71963378434726,"lng":-122.12317730385277},
  {"lat":37.71989140902889,"lng":-122.12327056837349},
  {"lat":37.71996406523366,"lng":-122.12293987126031},
  {"lat":37.72022169007679,"lng":-122.12303313537089},
  {"lat":37.72029434563224,"lng":-122.1227024365494},
  {"lat":37.72036700028995,"lng":-122.12237173707884},
  {"lat":37.720624625543145,"lng":-122.12246499971997},
  {"lat":37.720697279551494,"lng":-122.12213429854108},
  {"lat":37.72076993266221,"lng":-122.12180359671309},
  {"lat":37.72102755832534,"lng":-122.12189685788478},
  {"lat":37.72110021078671,"lng":-122.12156615434847},
  {"lat":37.72117286235033,"lng":-122.12123545016307},
  {"lat":37.72124551301622,"lng":-122.12090474532862},
  {"lat":37.721503139337784,"lng":-122.12099800397148},
  {"lat":37.721575789354326,"lng":-122.12066729742865},
  {"lat":37.72164843847313,"lng":-122.12033659023678},
  {"lat":37.721906065204706,"lng":-122.12042984741006},
  {"lat":37.721978713674176,"lng":-122.12009913850981},
  {"lat":37.72205136124589,"lng":-122.11976842896048},
  {"lat":37.72230898838748,"lng":-122.11986168466419},
  {"lat":37.722381635309844,"lng":-122.11953097340648},
  {"lat":37.72245428133439,"lng":-122.11920026149971},
  {"lat":37.72271190888606,"lng":-122.11929351573374},
  {"lat":37.72278455426133,"lng":-122.11896280211859},
  {"lat":37.7228571987388,"lng":-122.11863208785439},
  {"lat":37.72311482670043,"lng":-122.11872534061871},
  {"lat":37.723187470528536,"lng":-122.1183946246461},
  {"lat":37.723445098651794,"lng":-122.11848787700008},
  {"lat":37.723517741830584,"lng":-122.11815715931903},
  {"lat":37.723590384111546,"lng":-122.11782644098894},
  {"lat":37.72366302549471,"lng":-122.11749572200981},
  {"lat":37.72392065427644,"lng":-122.11758897183461},
  {"lat":37.72399329501027,"lng":-122.11725825114703},
  {"lat":37.72373566598012,"lng":-122.11716500238167},
  {"lat":37.72380830556767,"lng":-122.11683428210449},
  {"lat":37.72388094425749,"lng":-122.11650356117832},
  {"lat":37.72395358204946,"lng":-122.11617283960314},
  {"lat":37.72402621894369,"lng":-122.11584211737896},
  {"lat":37.72409885494008,"lng":-122.11551139450579},
  {"lat":37.72417149003868,"lng":-122.11518067098365},
  {"lat":37.72391385943122,"lng":-122.11508742922392},
  {"lat":37.7239864933836,"lng":-122.11475670611223},
  {"lat":37.72372886244105,"lng":-122.11466346606095},
  {"lat":37.72365622873709,"lng":-122.11499418811319},
  {"lat":37.72358359413529,"lng":-122.11532490951645},
  {"lat":37.72351095863576,"lng":-122.11565563027071},
  {"lat":37.72343832223833,"lng":-122.11598635037601},
  {"lat":37.72336568494314,"lng":-122.11631706983233},
  {"lat":37.723108055155784,"lng":-122.11622382513282},
  {"lat":37.72303541721125,"lng":-122.11655454288073},
  {"lat":37.722777787585514,"lng":-122.1164612977708},
  {"lat":37.72270514899154,"lng":-122.1167920138103},
  {"lat":37.722447519527364,"lng":-122.11669876828997},
  {"lat":37.72237488028403,"lng":-122.11702948262108},
  {"lat":37.72211725098145,"lng":-122.11693623669032},
  {"lat":37.7220446110888,"lng":-122.11726694931306},
  {"lat":37.721971970298284,"lng":-122.11759766128684},
  {"lat":37.721714341405715,"lng":-122.11750441388634},
  {"lat":37.72164169996583,"lng":-122.11783512415173},
  {"lat":37.72156905762821,"lng":-122.11816583376812},
  {"lat":37.72131142914559,"lng":-122.11807258489792},
  {"lat":37.72123878615864,"lng":-122.11840329280597},
  {"lat":37.72116614227386,"lng":-122.11873400006503},
  {"lat":37.720908514201255,"lng":-122.11864074972513},
  {"lat":37.72083586966714,"lng":-122.11897145527588},
  {"lat":37.72057824175603,"lng":-122.11887820452567},
  {"lat":37.72050559657258,"lng":-122.11920890836808},
  {"lat":37.72024796882305,"lng":-122.11911565720757},
  {"lat":37.720175322990244,"lng":-122.11944635934169},
  {"lat":37.72010267625971,"lng":-122.11977706082678},
  {"lat":37.719845048920106,"lng":-122.11968380819671},
  {"lat":37.71977240154025,"lng":-122.12001450797352},
  {"lat":37.719514774362175,"lng":-122.11992125493316},
  {"lat":37.719442126332915,"lng":-122.12025195300173},
  {"lat":37.7191844993164,"lng":-122.12015869955111},
  {"lat":37.7189268722129,"lng":-122.12006544674952},
  {"lat":37.718854223782764,"lng":-122.12039614205054},
  {"lat":37.71833896981202,"lng":-122.12020963627586},
  {"lat":37.7182663209809,"lng":-122.12054032880944},
  {"lat":37.718193671252124,"lng":-122.12087102069398},
  {"lat":37.71812102062561,"lng":-122.12120171192956},
  {"lat":37.71804836910139,"lng":-122.1215324025161},
  {"lat":37.71797571667945,"lng":-122.12186309245364},
  {"lat":37.717718090805676,"lng":-122.12176983524374},
  {"lat":37.717645437734426,"lng":-122.12210052347308},
  {"lat":37.7173878120221,"lng":-122.12200726585303},
  {"lat":37.717315158301595,"lng":-122.12233795237417},
  {"lat":37.717572783765434,"lng":-122.1224312110534}
];


  